import React, { useState } from 'react';
import { ReactComponent as AddIcon } from 'assets/icons/add-counter-icon.svg';
import { ReactComponent as SubtractIcon } from 'assets/icons/minus-counter-icon.svg';
import { ReactComponent as EditIcon } from 'assets/icons/edit-icon.svg';
import { ReactComponent as DeleteIcon } from 'assets/icons/delete.svg';
import { ReactComponent as ArrowDownIcon } from 'assets/icons/gray-arrow-down-icon.svg';
import { OrderDetailsType } from 'models/order.model';
import { formatNumber } from 'utils/functions';

type Props = {
  order: OrderDetailsType;
};

const UpdateMealCard = ({ order }: Props) => {
  const [expanded, setExpanded] = useState(true);

  return (
    <div className='p-2 bg-white'>
      <div className='flex items-center justify-between  border-b border-[#E2E7EE]'>
        <h3 className='font-bold py-3 text-sm text-[#858585]'>{order.brand}</h3>
        <div>
          <button
            className='bg-[#F7F7F7] p-2 rounded-full'
            onClick={() => setExpanded((prev) => !prev)}>
            <ArrowDownIcon
              className={`transition-transform duration-200 ${
                expanded ? 'rotate-180' : 'rotate-0'
              }`}
            />
          </button>
        </div>
      </div>

      {expanded && (
        <div className='flex justify-between items-start py-5 gap-4'>
          <div className='flex items-start gap-2'>
            <div className='flex gap-2 items-center'>
              <SubtractIcon width={18} />
              <p>{order.quantity}</p>
              <AddIcon width={18} />
            </div>
            <div className='flex flex-col gap-2'>
              {order.meal.map((meal) => (
                <ul key={meal.id} className='flex flex-col gap-2'>
                  <li className='text-sm text-[#1A1A1A]'>
                    {meal.meal} <span>({formatNumber(meal.amount)})</span>
                  </li>
                  {meal.addons.map((addon) => (
                    <li key={addon.id} className='text-xs text-[#858585]'>
                      {addon.quantity}x {addon.name}
                    </li>
                  ))}
                </ul>
              ))}
            </div>
          </div>
          <div className='flex gap-2 items-center'>
            <EditIcon width={14} />
            <DeleteIcon width={14} />
          </div>
        </div>
      )}
    </div>
  );
};

export default UpdateMealCard;
